import React from 'react';

interface DocumentIconProps {
    className?: string;
}

export const DocumentIcon: React.FC<DocumentIconProps> = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
        focusable="false"
    >
        <path d="M6.5 3.5h7l4 4v13h-11z" />
        <path d="M13.5 3.5v4h4M9 12h6M9 15h6M9 9h1.5" />
    </svg>
);

export default DocumentIcon;
